// extracted by mini-css-extract-plugin
export default {"sticker":"styles_sticker__1NVmd","container":"styles_container__Ov3WS","empty":"styles_empty__GSnsC","empty__blur":"styles_empty__blur__UQRH8"};